/**
 * Created by lari on 27/04/2017.
 */
(function () {
    'use strict';
    angular.module('vcexam')
      .component('currentexamscomments', {
        restrict: 'E',
        bindings: {
          consultid: '<'
        },
        template: `
          <span class="btn btn-warning btn-xs"
                ng-show="vm.examinations.length"
                popover-trigger="'outsideClick'"
                uib-popover-template="vm.popover"
                popover-title="Anmerkungen zu den Untersuchungen"
                popover-placement="auto bottom"><i class="fa fa-list-ul"></i></span>
          
          
          <script type="text/ng-template" id="examcomments_popver.tpl.html">
            <div>
              <div ng-repeat="exam in vm.examinations  | filter: {active: true}">
                <h5 ng-bind="exam.template.displayname" style="font-weight: bold"></h5>
                <span ng-show="exam.template.comments.avalues.length > 0" ng-repeat="val in exam.template.comments.avalues">{{val.name}}{{$last ? '' : ', '}}</span>
                <span ng-hide="exam.template.comments.avalues.length > 0"> Keine Anmerkungen</span>
              </div>
          
          <p class="alert alert-warning" style="margin-top: 10pt;">
            Die Anmerkungen der einzelnen Untersuchungen werden <strong>NICHT</strong> automatisch in den Gesamtbefund/Arztbrief übernommen.</p>
            </div>
          </script>
      `,
        controllerAs: 'vm',
        controller: ['$log', 'Rlog', 'Exam', 'vertxEventBusService', '$window',
          function ($log, Rlog, Exam, vertxEventBusService, $window) {
            let vm = this;

            vm.popover = 'examcomments_popver.tpl.html';
            vm.$onInit = function () {
              if (angular.isDefined(vm.consultid)) {
                let query = {consultid: vm.consultid};
                Exam.$search(query).$then(function (exams) {
                  vm.examinations = exams;
                })
              }
            };

            // vm.consultid might be late propagating, get exams on first change
            vm.$onChanges = function (changes) {
              if (!changes.isFirstChange) {
                vm.consultid = changes.consultid.currentValue;
                if (angular.isDefined(vm.consultid)) {
                  Exam.$search({consultid: vm.consultid}).$then(function (exams) {
                    vm.examinations = exams;
                  }, function (err) {
                    $log.error('exam lookup failed in currentexamstherapies for consultid id: ', vm.consultid);
                    Rlog.error('exam', 'currentexamstherapies', 'exam lookup failed', {consultid: vm.consultid});
                  });
                }
              }
            };

            const examsUpdateHandler = function (message) {
              // $log.debug('exam update mesg: ', message);
              if (angular.isDefined(vm.examinations)){
                vm.examinations.$refresh();
              }
            };

            $log.debug('[Vert.x subscribe] examinations.update');
            vertxEventBusService.on('examinations.update', {}, examsUpdateHandler);

            vm.$onDestroy = function () {
              $log.debug('[Vert.x unsubscribe] examinations.update');
              vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
            };


          }] // controller
      }); // component

// klammerfriedhof
  }());